// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerReviews__selfBlocked":"gu_a bhm_ea bhm_va bhm_ts bhm_vm bhm_vh"};